import { MsgReadStatusMsg } from '../../protobuf/msgReadStatus';
import { ByteUtil, GuidUtil } from '../../utils/index';
import { Constant } from '../../utils/constant';
// import { IRequestMsg, RequestMsg } from './../../protobuf/request';
import { PullRequest } from './../../protobuf/pullMsg';
export default class MsgReadStatusBiz {
    static sendMsgReadStatus(clientStater, fromGuid, targetGuid, startMsgGuid, endMsgGuid) {
        let guid = GuidUtil.nextId();
        let _msg = this.buildMsg(guid, fromGuid, targetGuid, startMsgGuid, endMsgGuid);
        return this.sendMsg(clientStater, _msg, guid);
    }
    //发送消息
    static sendMsg(clientStater, msg, guid) {
        return new Promise((reslove, reject) => {
            let _msgByte = this.encodeMsg(msg);
            clientStater.send(_msgByte);
            clientStater.onevent(guid, (response) => {
                if (response.code == 200) {
                    reslove({ code: response.code, msg: response });
                }
                else {
                    reject({ code: response.code, msg: response });
                }
            });
        });
    }
    //拉取未读消息回执
    static pullReadStatusMsg(clientStater, fromGuid, targetGuid) {
        return new Promise((reslove, reject) => {
            let _guid = GuidUtil.nextId();
            var _historyMsg = {
                // 协议参数
                guid: _guid,
                version: 1,
                fromGuid: fromGuid,
                targetGuid: targetGuid,
                pullType: PullRequest.PullType.MSG_READ_STATUS
            };
            //编码
            let utf8 = PullRequest.encode(_historyMsg).finish();
            let sendByte = ByteUtil.unionUint8Array([
                ByteUtil.intArrToBytes([utf8.length, Constant.SendType.PULL]),
                utf8
            ]);
            clientStater.send(sendByte);
            clientStater.onevent(_guid, (response) => {
                if (response.code == 200) {
                    reslove({ code: response.code, msg: response });
                }
                else {
                    reject({ code: response.code, msg: response });
                }
            });
        });
    }
    static buildMsg(guid, fromGuid, targetGuid, startMsgGuid, endMsgGuid) {
        var _msg = {
            version: 0,
            guid: guid,
            fromGuid: fromGuid,
            targetGuid: targetGuid,
            msgGuid: [],
            startMsgGuid: startMsgGuid,
            endMsgGuid: endMsgGuid
        };
        return _msg;
    }
    static encodeMsg(msg) {
        //编码
        let utf8 = MsgReadStatusMsg.encode(msg).finish();
        let sendByte = ByteUtil.unionUint8Array([
            ByteUtil.intArrToBytes([utf8.length, Constant.SendType.MSG_READ_STATUS]),
            utf8
        ]);
        return sendByte;
    }
}
//# sourceMappingURL=msgReadStatusBiz.js.map